import { FormControlLabel } from '@material-ui/core';
import { CheckBox, Typography } from '@thingsw/pitta-design-system';
import React from 'react';
import { THEME } from '../../features/Theme/slice';
import { RootState } from '../../features/store';
import { useSelector } from 'react-redux';

interface SurveyCheckBoxProps {
  item: {
    key: string;
    value: string;
  };
  reasonList: string[];
  setReasonList: (reasonList: string[]) => void;
}

const SurveyCheckBox = ({
  item,
  reasonList,
  setReasonList,
}: SurveyCheckBoxProps) => {
  const { colors, color } = useSelector((state: RootState) => state[THEME]);

  return (
    <FormControlLabel
      style={{
        gap: 6,
        alignItems: 'start',
        margin: 0,
        marginLeft: -2,
      }}
      control={
        color === 'dark' ? (
          <CheckBox
            checkedIcon={
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <g clipPath='url(#clip0_4800_81986)'>
                  <rect x='5' y='5' width='14' height='14' fill='white' />
                  <path
                    d='M9.98438 17.0156L18.9844 8.01562L17.5781 6.5625L9.98438 14.1562L6.42188 10.5938L5.01562 12L9.98438 17.0156ZM18.9844 3C19.5469 3 20.0156 3.20312 20.3906 3.60938C20.7969 3.98438 21 4.45312 21 5.01562V18.9844C21 19.5469 20.7969 20.0312 20.3906 20.4375C20.0156 20.8125 19.5469 21 18.9844 21H5.01562C4.45312 21 3.96875 20.8125 3.5625 20.4375C3.1875 20.0312 3 19.5469 3 18.9844V5.01562C3 4.45312 3.1875 3.98438 3.5625 3.60938C3.96875 3.20312 4.45312 3 5.01562 3H18.9844Z'
                    fill='#505054'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_4800_81986'>
                    <rect width='24' height='24' fill='white' />
                  </clipPath>
                </defs>
              </svg>
            }
            checked={reasonList.includes(item.value)}
            color='primary'
            onClick={() => {
              if (reasonList.includes(item.value)) {
                setReasonList(reasonList.filter((i) => i !== item.value));
                return;
              }
              setReasonList([...reasonList, item.value]);
            }}
            icon={
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <g clipPath='url(#clip0_4800_81996)'>
                  <rect x='5' y='5' width='14' height='14' fill='#EEEEF3' />
                  <path
                    d='M18.9844 3C19.5156 3 19.9844 3.20312 20.3906 3.60938C20.7969 4.01563 21 4.48438 21 5.01562V18.9844C21 19.5156 20.7969 19.9844 20.3906 20.3906C19.9844 20.7969 19.5156 21 18.9844 21H5.01562C4.48438 21 4.01562 20.7969 3.60938 20.3906C3.20312 19.9844 3 19.5156 3 18.9844V5.01562C3 4.48438 3.20312 4.01563 3.60938 3.60938C4.01562 3.20312 4.48438 3 5.01562 3H18.9844ZM18.9844 5.01562H5.01562V18.9844H18.9844V5.01562Z'
                    fill='#505054'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_4800_81996'>
                    <rect width='24' height='24' fill='white' />
                  </clipPath>
                </defs>
              </svg>
            }
          />
        ) : (
          <CheckBox
            checked={reasonList.includes(item.value)}
            color='primary'
            onClick={() => {
              if (reasonList.includes(item.value)) {
                setReasonList(reasonList.filter((i) => i !== item.value));
                return;
              }
              setReasonList([...reasonList, item.value]);
            }}
          />
        )
      }
      label={
        <Typography
          variant='Body'
          style={{
            minHeight: 30,
            display: 'flex',
            alignItems: 'center',
          }}
          htmlColor={colors.primary['2']}
        >
          {item.value}
        </Typography>
      }
    />
  );
};

export default SurveyCheckBox;
